import styled from 'styled-components';

import { Text as TextLayoutComponent, ScrollBarContainer } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 170px;
  max-width: 170px;
  border-radius: 3px;
  margin-right: 8px;
  padding: 20px;
  background: ${({ theme }) => theme.color.cardSortBackground};

  @media (min-width: 768px) {
    margin-right: 20px;
    min-width: 270px;
    max-width: 270px;
  }
`;

export const Text = styled(TextLayoutComponent)``;

export const List = styled.div`
  margin: 10px 0px;
  height: 100%;
`;

export const ScrollBar = styled(ScrollBarContainer)``;
